/**
 * @const AUDIT_REPORT_RUNS
 * @type {string}
 */
export const AUDIT_REPORT_RUNS = 'AUDIT_REPORT_RUNS';

/**
 * @const AUDIT_REPORT_RESET
 * @type {string}
 */
export const AUDIT_REPORT_RESET = 'AUDIT_REPORT_RESET';
